import { ContactUs, CopyrightFooter } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Col, Panel, Row, Well, Tooltip } from 'react-bootstrap'
import { AdditionalIndicesChart } from 'app/components/visualizations/AdditionalIndicesChart';
import { AdditionalIndicesTable } from 'app/components/visualizations/AdditionalIndicesTable';

class Indices extends Container<{}, {}> {

  state = {
    longMonthName: 'December',
    shortMonthName: 'Dec',
    fiscalYear: null,
    isLoggedIn: false,
    apiKey: null,
    username: null,
    indicies: [],
    givIndexAllEnabled: false,
    givAppreciationEnabled: false,
    givBalancedEnabled: false,
    givOtherEnabled: false,
    givPreservationEnabled: false,
    givSmallEnabled: false,
    givMediumEnabled: false,
    givLargeEnabled: false,
    foundationMarkIndexEnabled: false,
    cpiEnabled: false,
    spEnabled: true,
    sfEnabled: true,
    barclayEnabled: true,
    alwaysEnabled: true,
    tableData: [],
  }

  mapAppStateToContainerState(appState: IAppState): {} {
    const isLoggedIn = !!appState.User.username
    const username = appState.User.username
    const key = appState.User.token
    return { isLoggedIn, username, apiKey: key, shortMonthName: 'Dec', fiscalYear: null };
  }

  componentWillMount() {
    super.componentWillMount()
  }

  componentDidMount() {
  }

  renderButtonClasses() {
    return "list-group-item list-group-item-action"
  }

  renderCheck(shouldBeChecked: boolean) {
    return shouldBeChecked ? <i className="fa fa-check text-success" style={{ fontSize: '2.0rem' }}></i> : null
  }


  render() {
    const { givIndexAllEnabled,
      givAppreciationEnabled,
      givBalancedEnabled,
      givOtherEnabled,
      givPreservationEnabled,
      givSmallEnabled,
      givMediumEnabled,
      givLargeEnabled,
      foundationMarkIndexEnabled,
      cpiEnabled,
      spEnabled,
      sfEnabled,
      barclayEnabled,
      alwaysEnabled, } = this.state
    return (
      <section>
        <section className="container margin-y-xl" style={{ overflowX: 'hidden' }}>
          <Row>
            <Col sm={12}>
              <header>
                <h5 style={{ marginTop: 0 }}>The GIV Performance Index is constructed using the 12 FoundationMark Indices.  The FoundationMark Indices represent the median return for foundations in the corresponding month.</h5>
              </header>
            </Col>
          </Row>
          <Row style={{ paddingTop: '10px' }}>
            <Col sm={12} md={4}>
              <Panel style={{ padding: '10px' }}>
                <header style={{ fontSize: '2.0rem' }}>Portfolio Strategy&nbsp;<a href="#/faq?id=portfolioStrategy"><i className="fa fa-info-circle" style={{ color: '#4545da' }}></i></a></header>
                <div className="list-group">
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givAppreciationEnabled: !this.state.givAppreciationEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givAppreciationEnabled)}GIV Appreciation</a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givBalancedEnabled: !this.state.givBalancedEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givBalancedEnabled)}GIV Balanced </a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givOtherEnabled: !this.state.givOtherEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givOtherEnabled)}GIV Investment - Other </a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givPreservationEnabled: !this.state.givPreservationEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givPreservationEnabled)}GIV Preservation </a>
                </div>
              </Panel>
            </Col>
            <Col sm={12} md={4}>
              <Panel style={{ padding: '10px' }}>
                <header style={{ fontSize: '2.0rem' }}>Asset Levels</header>
                <div className="list-group">
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givSmallEnabled: !this.state.givSmallEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givSmallEnabled)}GIV $1 mm - $10 mm</a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givMediumEnabled: !this.state.givMediumEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givMediumEnabled)}GIV $10 mm - $50 mm</a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ givLargeEnabled: !this.state.givLargeEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.givLargeEnabled)}GIV $50+ mm</a>
                </div>
              </Panel>
            </Col>
            <Col sm={12} md={4}>
              <Panel style={{ padding: '10px' }}>
                <header style={{ fontSize: '2.0rem' }}>Public Markets</header>
                <div className="list-group">
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ spEnabled: !this.state.spEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.spEnabled)}S &amp; P 500</a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ sfEnabled: !this.state.sfEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.sfEnabled)}60 / 40 Index</a>
                  <a style={{ border: '1px solid #1F5B8F' }} onClick={() => this.setState({ barclayEnabled: !this.state.barclayEnabled })} className={this.renderButtonClasses()}>{this.renderCheck(this.state.barclayEnabled)}Barclays Aggr. Index</a>
                </div>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Panel>
                <AdditionalIndicesChart givIndexAllEnabled={givIndexAllEnabled}
                  givAppreciationEnabled={givAppreciationEnabled}
                  givBalancedEnabled={givBalancedEnabled}
                  givOtherEnabled={givOtherEnabled}
                  givPreservationEnabled={givPreservationEnabled}
                  givSmallEnabled={givSmallEnabled}
                  givMediumEnabled={givMediumEnabled}
                  givLargeEnabled={givLargeEnabled}
                  foundationMarkIndexEnabled={foundationMarkIndexEnabled}
                  cpiEnabled={cpiEnabled}
                  spEnabled={spEnabled}
                  sfEnabled={sfEnabled}
                  barclayEnabled={barclayEnabled}
                  alwaysEnabled={alwaysEnabled} />
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Panel>
                <AdditionalIndicesTable givIndexAllEnabled={givIndexAllEnabled}
                  givAppreciationEnabled={givAppreciationEnabled}
                  givBalancedEnabled={givBalancedEnabled}
                  givOtherEnabled={givOtherEnabled}
                  givPreservationEnabled={givPreservationEnabled}
                  givSmallEnabled={givSmallEnabled}
                  givMediumEnabled={givMediumEnabled}
                  givLargeEnabled={givLargeEnabled}
                  foundationMarkIndexEnabled={foundationMarkIndexEnabled}
                  cpiEnabled={cpiEnabled}
                  spEnabled={spEnabled}
                  sfEnabled={sfEnabled}
                  barclayEnabled={barclayEnabled}
                  alwaysEnabled={alwaysEnabled} />
              </Panel>
            </Col>
          </Row>
          <Row className="margin-y-sm">
            <Col sm={4} className="margin-y-sm">
              <Button bsSize="lg" bsStyle="default" block href="#/faq?id=representativeBenchmarks">
                <span className="hidden-sm">FoundationMark&nbsp;</span>
                    Universe
                  </Button>
            </Col>
            <Col sm={4} className="margin-y-sm">
              <Button bsSize="lg" bsStyle="default" block href="#/faq?id=portfolioFoundations">
                Methodology
                  </Button>
            </Col>
            <Col sm={4} className="margin-y-sm">
              <Button bsSize="lg" bsStyle="default" block href="#/faq?id=aboutIndices">
                FoundationMark Indices Change
                  </Button>
            </Col>
          </Row>
        </section>

        <ContactUs />
        <CopyrightFooter />
      </section >
    )
  }
}

export {
  Indices
}



// WEBPACK FOOTER //
// ./src/app/containers/Indices/index.tsx